import request from "@/utils/request";

export default function agentDisableRfIdCard(id) {
  return request({
    url: `/user/agent/RFIDCardController/disableRfIdCard?id=${id}`,
    method: "post",
  });
}
